/**
 * Roles Constants
 * Stores information related to Application Roles.
 */
export const RolesConstants = Object.freeze({
    HOMEOWNER: 'homeowner',
    CONTRACTOR: 'contractor'
})